import * as scene from '../scene.js';
import * as loader from '../loader.js';
import * as audio from '../audio.js';
import * as triangle from '../triangle.js';
import { createPanner } from '../audio/panner.js';

export {
    init,
}

const POIs = [
    {
        name: 'inspire-1',
        position: { x: 2, y: 21, z: 0 },
        color: 'white',
        sound: {
            name: 'inspire-1',
            gain: 0,
        },
        onStart() {
            audio.panner.play(this);
        },
    },
    {
        name: 'inspire-2',
        position: { x: 2, y: 22, z: 0 },
        color: 'white',
        sound: {
            name: 'inspire-2',
            gain: 0,
            delay: 1.3,
        },
        onStart() {
            audio.panner.play(this);
        },
    },
    {
        name: 'inspire-3',
        position: { x: 2, y: 23, z: 0 },
        color: 'white',
        sound: {
            name: 'inspire-3',
            gain: 0,
            delay: 0.9,
        },
        onStart() {
            audio.panner.play(this);
        },
    },
    {
        name: 'inspire-4',
        position: { x: 2, y: 24, z: 0 },
        color: 'white',
        sound: {
            name: 'inspire-4',
            gain: 0,
            delay: 2.4,
        },
        onStart() {
            audio.panner.play(this);
        },
    },
    {
        name: 'expire-1',
        position: { x: 4, y: 21, z: 0 },
        color: 'white',
        sound: {
            name: 'expire-1',
            gain: 0,
        },
        onStart() {
            audio.panner.play(this);
        },
    },
    {
        name: 'expire-2',
        position: { x: 4, y: 22, z: 0 },
        color: 'white',
        sound: {
            name: 'expire-2',
            gain: 0,
            delay: 2.1,
        },
        onStart() {
            audio.panner.play(this);
        },
    },
    {
        name: 'expire-3',
        position: { x: 4, y: 23, z: 0 },
        color: 'white',
        sound: {
            name: 'expire-3',
            gain: 0,
            delay: 1.6,
        },
        onStart() {
            audio.panner.play(this);
        },
    },
    {
        name: 'expire-4',
        position: { x: 4, y: 24, z: 0 },
        color: 'white',
        sound: {
            name: 'expire-4',
            gain: 0,
            delay: 0.9,
        },
        onStart() {
            audio.panner.play(this);
        },
    },
    {
        name: 'respire',
        position: { x: 3, y: 22.5, z: 0 },
        color: 'white',
        invisible: true,
        collision: {
            radius: 3,
        },
        onEnter() {
            triangle.drop('stonehenge-triangle-5', this.position, {
                collisionRadius: 0.5,
                offset: { x: 3, y: 0 },
                delay: 7,
                gain: 0,
            });
        },
    },
];

const sounds = [
    { name: 'inspire-1', url: new URL('../../sound/Inspir1.wav', import.meta.url) },
    { name: 'inspire-2', url: new URL('../../sound/Inspir2.wav', import.meta.url) },
    { name: 'inspire-3', url: new URL('../../sound/Inspir3.wav', import.meta.url) },
    { name: 'inspire-4', url: new URL('../../sound/Inspir4.wav', import.meta.url) },
    { name: 'expire-1', url: new URL('../../sound/Expir1.wav', import.meta.url) },
    { name: 'expire-2', url: new URL('../../sound/Expir2.wav', import.meta.url) },
    { name: 'expire-3', url: new URL('../../sound/Expir3.wav', import.meta.url) },
    { name: 'expire-4', url: new URL('../../sound/Expir4.wav', import.meta.url) },
];

const images = [
];

function init() {
    scene.addPOIs(POIs);
    //loader.addImages(images);
    loader.addSounds(sounds);
};
